import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { container, focusRing } from '../../utils/styles';
interface PageHeaderProps {
  crumb: string;
  title: string;
  intro: string;
  children?: React.ReactNode;
}
export function PageHeader({
  crumb,
  title,
  intro,
  children
}: PageHeaderProps) {
  const {
    t
  } = useLanguage();
  return <section className="bg-brand-dark text-white" data-id="element-386" data-mp="2h3infmvgy9sr">
      <div className={`${container} py-14 sm:py-20`} data-id="element-387" data-mp="2c4ecorswc40b">
        <nav aria-label={t({
        en: 'Breadcrumb',
        es: 'Ruta de navegación'
      })} data-id="element-388" data-mp="2c5pcyhn4utmo">
          <ol className="flex items-center gap-2 text-sm text-white/75" data-id="element-389" data-mp="274jj2ghql0bk">
            <li data-id="element-390" data-mp="227jeka0jc5mk">
              <Link to="/" className={`rounded hover:text-white hover:underline ${focusRing}`} data-id="element-391" data-mp="225yk0ke80mop">
                {t({
                en: 'Home',
                es: 'Inicio'
              })}
              </Link>
            </li>
            <li aria-hidden="true" data-id="element-392" data-mp="qrbjetnfnwkx">
              <ChevronRightIcon className="h-4 w-4" data-id="element-393" data-mp="qq9vvpp8dhmb" />
            </li>
            <li aria-current="page" className="text-white" data-id="element-394" data-mp="m7gqcdmls4or">
              {crumb}
            </li>
          </ol>
        </nav>
        <div className="mt-6 grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-395" data-mp="r4qoqiryzqoq">
          <div className="lg:col-span-7" data-id="element-396" data-mp="c77r0qxbe355">
            <h1 className="text-4xl font-bold leading-tight sm:text-5xl" data-id="element-397" data-mp="cac1g61dhv49">{title}</h1>
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-white/85" data-id="element-398" data-mp="h5hmz3qv57rt">{intro}</p>
          </div>
          {children && <div className="lg:col-span-5 lg:justify-self-end" data-id="element-399" data-mp="3e32stl7z0j6">{children}</div>}
        </div>
      </div>
    </section>;
}